import { withCompInfo } from '../../../core/withCompInfo'
import { WTwitterTweetDefinition, WTwitterTweetProps } from './types'
import { getLanguage } from '../common/utils'

export const props = withCompInfo<WTwitterTweetProps, WTwitterTweetDefinition>(
	['compData', 'compProps', 'compLayout', 'language', 'isMobileView'],
	({ compData, compProps, compLayout, language, isMobileView }) => {
		return {
			defaultText: compData.defaultText,
			accountToFollow: compData.accountToFollow,
			isMobileView,
			lang: getLanguage(compProps.dataLang, language),
			width: compLayout.width || 0,
			height: compLayout.height || 0,
		}
	}
)
